export const ANALYTICS_SCREENS = ["home", "periodicals", "podcasts", "reader", "podcast", "about", "admin"] as const;
export const ANALYTICS_FEATURES = ["nav_home", "nav_periodicals", "nav_podcasts", "search_open", "search_submit", "toc_open", "toc_select", "language_zh", "language_en", "reading_settings", "theme_change", "font_change", "immersive_toggle", "discussion_open", "comment_submit", "ai_open", "ai_submit", "ai_citation", "podcast_play", "podcast_pause", "podcast_speed", "podcast_chapter", "podcast_mode", "publication_filter", "podcast_filter", "about_open", "logout", "admin_open"] as const;
export type AnalyticsScreen = typeof ANALYTICS_SCREENS[number];
export type AnalyticsFeature = typeof ANALYTICS_FEATURES[number];
export type AnalyticsContentType = "issue" | "article" | "podcast";
export type AnalyticsEvent = {
  id: string;
  sessionId: string;
  type: "session_start" | "page_view" | "feature_click" | "read_time";
  screen: AnalyticsScreen;
  feature?: AnalyticsFeature;
  contentType?: AnalyticsContentType;
  contentId?: string;
  durationSeconds?: number;
};
export type AnalyticsBatch = { events: AnalyticsEvent[] };
export type AnalyticsMetrics = {
  logins: number; loginUsers: number; activeUsers: number; readers: number; sessions: number; pageViews: number;
  opens: number; engagedReads: number; completedReads: number; audioStarts: number; audioCompletions: number;
  readSeconds: number;
};
export type AnalyticsTrend = AnalyticsMetrics & { date: string };
export type AnalyticsContent = {
  contentType: AnalyticsContentType; contentId: string; title: string; publication: string | null;
  opens: number; engagedReads: number; completedReads: number; audioStarts: number; audioCompletions: number;
  readers: number; readSeconds: number;
};
export type AnalyticsUser = {
  id: string; name: string; role: "reader" | "editor" | "admin";
  lastLoginAt: string | null; lastActiveAt: string | null;
  logins: number; activeDays: number; pageViews: number; opens: number; engagedReads: number;
  completedReads: number; audioStarts: number; readSeconds: number;
};
export type AnalyticsDashboard = {
  ok: true;
  range: { start: string; end: string; days: number; timeZone: "Asia/Shanghai" };
  collectionStartedAt: string | null;
  generatedAt: string;
  summary: AnalyticsMetrics & { totalUsers: number; newUsers: number };
  trend: AnalyticsTrend[];
  popularContent: AnalyticsContent[];
  features: { feature: AnalyticsFeature; clicks: number; users: number }[];
  users: AnalyticsUser[];
  notes: string[];
};
